import { Component } from "vue-property-decorator";
import ConfigurationField from "../ConfigurationField.mixin";
import { ConfigurationFields } from "../declarations";
import Template from "./ActionButton.template.vue";

@Component({
  mixins: [Template]
})
export default class ConfigurationFieldActionButton extends ConfigurationField {
  protected defaultConfiguration: ConfigurationFields.FieldCustomConfiguration = {
    icon: "fal fa-function",
    label: "Placeholder"
  };
}
